import styled from 'styled-components'
import UpDownIcon from 'svgIcons/UpDownIcon'

export interface CircleInfoItemDesktopProps {
  infoTitle: string
  averageText: string
  averagePercent: number
  userPercent: number
}

const CircleInfoItemDesktop = ({
  averagePercent,
  averageText,
  infoTitle,
  userPercent,
}: CircleInfoItemDesktopProps) => {
  const isUp = userPercent >= 0

  return (
    <StyledWrapper>
      <div className="info-circle">
        <p>{infoTitle}</p>
        <div className="percent-box" data-is-up={isUp}>
          <span>{Math.abs(userPercent)}%</span>
          <UpDownIcon isUp={isUp} />
        </div>
      </div>
      <p>
        {averageText}
        <span>{averagePercent}문항</span>
      </p>
    </StyledWrapper>
  )
}

export default CircleInfoItemDesktop

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;

  > .info-circle {
    width: 224px;
    height: 224px;
    border: solid 1px #e8e8e8;
    background-color: #fff;
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 16px;

    > p {
      font-size: 18px;
      font-weight: 500;
      line-height: 1.33;
      letter-spacing: -0.72px;
      text-align: center;
      color: #333;
      white-space: pre-wrap;
    }

    > .percent-box {
      display: flex;
      align-items: center;
      color: #004eff;

      > span {
        font-size: 28px;
        font-weight: bold;
        letter-spacing: -1.12px;
        text-align: center;
      }

      &[data-is-up='true'] {
        color: #ef2929;
      }
    }
  }

  > p {
    font-size: 15px;
    font-weight: normal;
    line-height: 1.33;
    letter-spacing: -0.6px;
    text-align: center;
    color: #666666;
    > span {
      display: block;
      font-weight: 500;
    }
  }
`
